import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges, OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {CustomTableSaverService} from '../../../../../services/storage/custom-table-saver.service';
import {DataTableFiller} from '../../../../../model/data-table-filler';
import {AuthenticationService} from '../../../../../services/apiServices/security/authentication.service';
import {TemplateConfig, TemplatesConfig} from "../../../../../model/templatesConfig";
import {SelectItemGroup} from "primeng/api";
import {CreateDepositService} from "../../../../../services/apiServices/business/create-deposit.service";
import {CommonService} from "../../../../../services/apiServices/business/common.service";
import {TranslateService} from "@ngx-translate/core";
@Component({
  selector: 'app-folds-list',
  templateUrl: './folds-list.component.html',
  styleUrls: ['./folds-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FoldsListComponent implements AfterViewInit, OnChanges, OnInit {


  /**
   * fold selected inside the p-table
   */
  @Output() public selectFoldOutput: EventEmitter<any>;

  /**
   * depositColumns of the p-table based on criterias
   */
  @Input('columns') public columns;

  @Input('showDiscardColumn') public showDiscardColumn;
  public discardColumn: any;
  @Input('showDelayedsenddate') public showDelayedsenddate;
  public delayedsenddate: any;

  /**
   * fold selected inside the multiples dataTables
   */
  @Input('selectFoldInput') public selectFoldInput;

  /**
   * list of datas to fill the p-table
   */
  @Input('folds') public folds;
  public selectedFolds: any[];
  public selectedFold;
  @Input('selectionType') public selectionType: 'single' | 'multiple' | undefined | null;

  /**
   * here to call function from parent component (paginator  access)
   */
  @ViewChild('pdt_fold_list', {static: true}) pdt_fold_list;

  /**
   * here to get the default with (in px) of the p-table (to determine default column width)
   */
  @ViewChild('widthIdentifier', {static: true}) widthIdentifier: ElementRef;
  // public sortOrder: string;
  public sortField: string;

  public DataTableFiller = DataTableFiller;
  /**
   * the default with of a column
   */
  public defaultWidth;

  /**
   * only usefull in ngOnChanges to detect if the part of the model that has been update require a paginator reinit
   */
  public needToResetPaginator: boolean;

  /**
   * the page to navigate to using paginator from pdt_fold_list
   */
  public pageNumberAskedByUser;
  showSelectAll = false;
  forceSelectAll = false;
  defaultSortOrder= 1;

  private templates: any[];
  private templateConfig: TemplateConfig;

  /**
   * @param commonService
   * @param {CustomTableSaverService} customTableSaverService - here to save columns dispositions and width
   * @param authenticationService
   * @param translate
   * @param createDepositService
   */
  constructor(private commonService: CommonService,
              private customTableSaverService: CustomTableSaverService,
              private authenticationService: AuthenticationService,
              private translate: TranslateService,
              private createDepositService: CreateDepositService) {
    this.selectFoldOutput = new EventEmitter<any>();
    this.needToResetPaginator = false;
    this.showSelectAll = 'adminNumen'.toUpperCase() === authenticationService.getCurrentUser().idUser.toUpperCase();
    this.templates = [];
  }

  ngOnInit(): void {
    this.discardColumn = {
      header: 'FOLDS.LIST_COMPONENT.USER_JUSTIF_ACTION',
      field: 'sJustifaction',
      width: 200
    };
    this.selectedFolds = [];
    this.delayedsenddate = {
      header: 'FOLDS.LIST_COMPONENT.PLANNED_DATE',
      field: 'delayedsenddate',
      width: 200
    };
    this.selectedFold = null;
    for (let i = 0; i < this.columns.length; i++) {
      let col = this.columns[i];
      if(col.field === "template") {
        this.loadTemplates();
      }
    }
  }

  /**
   * determine the default with column
   */
  ngAfterViewInit(): void {
    this.defaultWidth = this.widthIdentifier.nativeElement.offsetWidth / this.columns.length;
  }

  /**
   * reset paginator input if a new request is performed
   */
  public ngOnChanges(): void {
    if (this.needToResetPaginator) {
      this.pageNumberAskedByUser = 1;
      this.pdt_fold_list.first = 0;
    }
    this.needToResetPaginator = true;
  }

  /**
   * emit selectedFold for 2 purposes: display details and unselect others
   * @param event
   */
  notifySelectedFolds(event: any): void {
    event.originalEvent.stopPropagation();
    if (event.checked) {
      this.selectedFolds.length = 0;
      if (this.forceSelectAll) {
        this.selectedFolds = this.folds;
      } else {
        for (let i = 0; i < 10; i++) {
          this.selectedFolds[i] = this.folds[this.pdt_fold_list.first + i];
        }
      }
    }
    this.selectFoldOutput.emit(this.selectedFolds);
    this.needToResetPaginator = false;
  }

  /**
   * handle the colResize (using customTableSaver)
   *
   * @param event - given by primeNg p-table
   */
  public handleChangeUserColSize(event: any) {
    // the col resizing is not working
    if ((5 + 2) > 2) {
      return;
    }
    // regex and string Operations are here to get the width from column style
    const regexp = new RegExp('width: [0-9]+.?[0-9]+');
    let width = regexp.exec(event.element.outerHTML)[0].toString();
    width = width.replace('width: ', '');

    const newProp = {
      columns: this.columns,
      cellHeader: this.columns[event.element.cellIndex].header,
      cellWidth: Number.parseFloat(width),
      defaultWidth: this.defaultWidth
    };

    this.customTableSaverService.updateFoldTableWidth(newProp);
  }

  /**
   * handle the col reorder (using customTableSaver)
   *
   * @param event - given by primeNg p-table
   */
  public handleChangeUserColOrder(event: any) {
    this.customTableSaverService.updateFoldTableOrder(event.columns, this.defaultWidth);
  }

  /**
   * determine if there is at least one entry in fold array
   * @return {boolean} - true if it's an empty array
   */
  public noEntryInDataTable(): boolean {
    return this.folds && this.folds.filter(x => !x.notSelectable).length === 0;
  }

  /**
   * set the new page inside p-table
   * If it's out of bound, it'll correct the user input like this:
   * if < 0 : go to the first page
   * if > number of pages : go the last page
   */
  public setNewPage(): void {

    let pageAsRowNumber = Math.floor((this.pageNumberAskedByUser - 1) * (DataTableFiller.NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS));

    if (pageAsRowNumber < 0) {
      this.pageNumberAskedByUser = 1;
      pageAsRowNumber = 0;
    }

    if (pageAsRowNumber >= this.pdt_fold_list.totalRecords) {
      this.pageNumberAskedByUser = this.getnumberOfPages();
      pageAsRowNumber = this.pdt_fold_list.totalRecords - (DataTableFiller.NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS);
    }

    this.pdt_fold_list.first = pageAsRowNumber;
  }

  /**
   * Permit to have a coherent input when the user use arrow to change pagination
   * @param {Event} event - the event thrown when the paginator change
   */
  public updateCurrentPage(event): void {
    this.pageNumberAskedByUser = Math.floor((event.first) / (DataTableFiller.NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS)) + 1;
  }

  /**
   * return the total number of pages
   * @return {number}
   */
  public getnumberOfPages(): number {
    return this.pdt_fold_list.totalRecords ? Math.ceil((this.pdt_fold_list.totalRecords) / (DataTableFiller.NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS)) : 0;
  }

  formatTimeStamp(stamp: number): string {
    if (stamp != null) {
      const date = new Date(stamp);
      const month = date.getMonth() + 1;
      const mm = (month < 10) ? '0' + month : month;
      const dd = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
      return dd + '/' + mm + '/' + date.getFullYear();
    }
    return '';
  }

  public getTemplateLabel(templateId: string) {
    for(const entry of this.templates) {
      for (const item of entry.items) {
        if(item.value === templateId) {
          return item.label;
        }
      }
    }
    return templateId;
  }

  loadTemplates(): void {
    this.createDepositService.getExpressDepositTemplates().subscribe(response => {
      this.templates = [];
      if (response.groups) {
        const templatesConfig = new TemplatesConfig(response);
        this.templateConfig = templatesConfig.getTemplateConfig();
        for (const g of this.templateConfig.groups) {
          const entry: SelectItemGroup = {
            items: [],
            label: g.label,
            value: g.value
          };
          if (g.templates) {
            for (const p of g.templates) {
              entry.items.push({ label: p.label, value: p.value });
            }
          }
          this.templates.push(entry);
        }
      } else if (response.customerId !== null && response.customerId !== undefined) {
        return;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_MSG')
        });
      }
    });
  }
}
